/**
 * Display label for the sender of an incoming group message.
 * Never falls back to message.contact.name — that is the group contact, not the participant.
 */
export function getGroupSenderLabel(message) {
  const nameUser = message?.nameUser?.trim();
  if (nameUser && nameUser.toLowerCase() !== "participante") return nameUser;
  const phone = String(message?.participantPhone || "").replace(/\D/g, "");
  if (phone) return phone;
  return nameUser || "Participante";
}

export default getGroupSenderLabel;
